import React from 'react'
import PropTypes from 'prop-types'
import autobind from '../../lib/autobind'
import '../../styles/index.scss'

const ESCAPE = 27

class Submenu extends React.Component {
  constructor (props, context) {
    super(props, context)
    autobind(this)
  }

  handleOnKeyDown (e) {
    if (e.keyCode === ESCAPE) {
      e.preventDefault()
      this.context.dropdown.closeSubmenu(0)
      this.context.dropdown.focusMenubarItem()
    }
  }

  render () {
    const { isOpen } = this.context.dropdown
    return (
      <div
        {...this.props}
        role='menu'
        aria-expanded={isOpen}
        aria-hidden={!isOpen}
        onKeyDown={this.handleOnKeyDown}
      >
        {this.props.children}
      </div>
    )
  }
}

Submenu.contextTypes = {
  dropdown: PropTypes.object
}

export default Submenu
